// src/components/adsRecords.jsx
import React, { useMemo, useState } from "react";
import { useRecordsStore } from "../../../../stores/useReordsStore";
import { useNavigate } from "react-router-dom";
import TokenPopup from "./TokenPopup";
import error from "../../../../assets/icons/warning/error_gray.svg";
import { Button } from "../../../../assets/components/ButtonGroup";

const titleMap = {
  1: "매장 홍보",
  2: "상품 소개",
  3: "이벤트",
};

// 날짜 파싱 유틸
const parseDate = (v) => {
  if (!v) return null;
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
};
const dateFromImagePath = (path) => {
  if (!path) return null;
  const m = path.match(/_(\d{14})\./); // e.g. ..._20250925014924.jpg
  if (!m) return null;
  const s = m[1];
  const d = new Date(
    Number(s.slice(0, 4)),
    Number(s.slice(4, 6)) - 1,
    Number(s.slice(6, 8)),
    Number(s.slice(8, 10)),
    Number(s.slice(10, 12)),
    Number(s.slice(12, 14))
  );
  return Number.isNaN(d.getTime()) ? null : d;
};
const pickDate = (r) =>
  parseDate(r.created_at) ||
  parseDate(r.updated_at) ||
  dateFromImagePath(r.image_path) ||
  parseDate(r.end_date) ||
  parseDate(r.start_date) ||
  new Date(0);

const AdsRecords = ({ tokenAll, onCreateClick = () => { } }) => {
  const records = useRecordsStore((s) => s.records);
  const navigate = useNavigate();
  const [showTokenModal, setShowTokenModal] = useState(false);

  // 이미지 있는 것만 → 날짜 계산 → 최신순
  const base = useMemo(() => {
    const withImg = (records || []).filter((r) => !!r?.image_path);
    return withImg
      .map((r) => ({ ...r, __date__: pickDate(r) }))
      .sort((a, b) => b.__date__ - a.__date__);
  }, [records]);

  // 최대 9개
  const items = base.slice(0, 9);

  const handleCreateClick = () => {
    // 토큰 검사
    if (tokenAll <= 0) {
      setShowTokenModal(true);
      return;
    }

    // 토큰 있으면 원래 동작 실행
    onCreateClick();
  };

  return (
    <section className="w-full">
      <h3 className="text-t2 text-text-default">7일간 홍보 기록</h3>

      {items.length === 0 ? (
        <div className="flex flex-col items-center justify-center pt-[20px]">
          <img src={error} alt="주의" className="w-[48px] h-[48px]" />
          <p className="text-t4 text-text-default pt-[20px]">이미지 생성 내역이 없어요</p>
          <p className="text-b2 text-text-subtler pt-[4px]">AI가 추천하는 이미지를 생성해 보세요</p>
        </div>
      ) : (
        <div className="pt-[16px] overflow-x-auto">
          <div className="flex gap-3">
            {items.map((rec, idx) => {
              const titleText = titleMap[Number(rec.title)] || "";

              return (
                <figure
                  key={(rec.image_path || "") + idx}
                  className="relative shrink-0 w-[132px] aspect-[3/4] overflow-hidden rounded-2xl bg-[#F2F3F8] cursor-pointer"
                  title={titleText}
                  onClick={() =>
                    navigate("/mycalendar/detail", {
                      state: { record: rec },
                    })
                  }
                >
                  <img
                    src={rec.image_path}
                    alt={titleText ? titleText : `uploaded-${idx + 1}`}
                    className="w-full h-full object-cover block"
                    loading="lazy"
                  />
                </figure>
              );
            })}
          </div>
        </div>
      )}

      <TokenPopup
        isOpen={showTokenModal}
        onClose={() => setShowTokenModal(false)}
      />
    </section>
  );
};

export default AdsRecords;
